import { gql } from '@apollo/client';
export const ALERTS = gql`query MyDeviceAlerts { myAlerts { unread publicKey pushConfigured items { id title message createdAt readAt } } }`;
export const READ_ALERTS = gql`mutation ReadDeviceAlerts($id: ID) { readAlerts(id: $id) }`;
const SUBSCRIBE = gql`mutation SubscribeDevice($subscription: String!) { subscribeDevice(subscription: $subscription) }`;
const UNSUBSCRIBE = gql`mutation UnsubscribeDevice($endpoint: String!) { unsubscribeDevice(endpoint: $endpoint) }`;
export const TEST_ALERT = gql`mutation TestDeviceAlert { testDeviceAlert }`;
export async function syncAppBadge(count) {
  try {
    if (count > 0) await navigator.setAppBadge?.(count);
    else await navigator.clearAppBadge?.();
    const registration = await navigator.serviceWorker?.getRegistration('/');
    registration?.active?.postMessage({ type: 'BADGE', count });
  } catch (_) { /* Badging is optional. */ }
}
export async function deviceSubscription() {
  const registration = await navigator.serviceWorker?.getRegistration('/');
  return registration?.pushManager?.getSubscription();
}
export async function refreshDeviceAlerts(client) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return false;
  const subscription = await deviceSubscription();
  if (!subscription) return false;
  await client.mutate({ mutation: SUBSCRIBE, variables: { subscription: JSON.stringify(subscription) } });
  return true;
}
export async function enableDeviceAlerts(client, publicKey) {
  if (!window.isSecureContext || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) throw Error('On iPhone or iPad, add Timely365 to your Home Screen and open it there first. On desktop, use a browser that supports notifications.');
  const permission = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
  if (permission !== 'granted') throw Error('Allow notifications in your browser or device settings to enable alerts.');
  await navigator.serviceWorker.register('/timely-sw.js', { scope: '/' });
  const registration = await navigator.serviceWorker.ready;
  const padded = publicKey.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - publicKey.length % 4) % 4);
  const applicationServerKey = Uint8Array.from(atob(padded), char => char.charCodeAt(0));
  const subscription = await registration.pushManager.getSubscription() || await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  await client.mutate({ mutation: SUBSCRIBE, variables: { subscription: JSON.stringify(subscription) } });
}
export async function disableDeviceAlerts(client) {
  try {
    const subscription = await deviceSubscription();
    if (subscription) {
      try { await client.mutate({ mutation: UNSUBSCRIBE, variables: { endpoint: subscription.endpoint } }); }
      finally { await subscription.unsubscribe(); }
    }
  } finally { await syncAppBadge(0); }
}
